export const PAYMENTS_MERCHANTS = [
  { type: 'cloudpayments', iframe: true },
  { type: 'tinkoff', iframe: true },
  { type: 'prodamus', iframe: true },
  { type: 'tinkoff_sbp', iframe: false },
  { type: 'paytabs', iframe: false },
  { type: 'terpay', iframe: false },
  { type: 'moneta', iframe: true },
  { type: 'moneta_v2', iframe: false },
  { type: 'rr', iframe: false },
  { type: 'instalment_tinkoff', iframe: false }
]
